import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { array } from 'prop-types'
import { makeImgResizerUrl, splitParagraphString } from '@jelly/utils'

// Import Components
import { CardReview } from '@jelly/components'

const BestPicksWrapper = styled.div``
const BestPickTitle = styled.h4`
	display: inline-block;
`
const ServiceName = styled.div`
	display: inline-block;
`

IndividualBestPicks.propTypes = {
	services: array.isRequired,
	servicesData: array.isRequired,
}

export function IndividualBestPicks(props) {
	const { services, servicesData } = props
	const [bestPicksData, setBestPicksData] = useState([])

	useEffect(() => {
		setBestPicksData(
			services.map((serviceGuid) => {
				return servicesData.find((service) => service.id === serviceGuid)
			})
		)
	}, [services, servicesData])

	return (
		<>
			{bestPicksData.map((service, i) => {
				const {
					bestPickDescription,
					company: { url },
					fullTitle,
					pricing,
					pricing: {
						affiliate: { link },
						selected,
					},
					review: { title, verdict },
					serviceName,
					thumbnail,
				} = service

				const paragraphs = splitParagraphString(bestPickDescription)

				return (
					<BestPicksWrapper key={i}>
						<BestPickTitle>
							{fullTitle}: <ServiceName>{serviceName}</ServiceName>
						</BestPickTitle>
						{paragraphs.map((paragraph, i) => {
							return <div key={i} dangerouslySetInnerHTML={{ __html: paragraph }} />
						})}
						<CardReview
							bottomLink={true}
							linkTo={{ title, url: service.canonical }}
							pricing={pricing}
							thumbnail={{ path: makeImgResizerUrl({ src: thumbnail, method: 'w', w: 250 }) }}
							title={serviceName}
							verdict={verdict}
							url={selected === 'affiliate' ? link : url}
						/>
					</BestPicksWrapper>
				)
			})}
		</>
	)
}
